import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import { PageDocsTraits } from "traits/page-docs-traits";
import { CodeContainerTraits } from "traits/code-container-traits";
import { Channel, safeClone } from "spyne";

export class ChannelSpyneDocsData extends Channel {
  constructor(name, props = {}) {
    name = "CHANNEL_SPYNE_DOCS_DATA";
    props.sendCachedPayload = true;
    props.traits = [PageDocsTraits];

    super(name, props);
  }

  onDataReceived(e) {
    this.props.data = {};
    this.props.data["appData"] = safeClone(e[0].payload);
    this.props.data["spyneDocsData"] = safeClone(e[1].payload);
    this.props.data.spyneDocsData["homePageHeroContent"] =
      this.props.data.spyneDocsData.homePageContent[0]?.heroContent;
    this.props.data.spyneDocsData.docsContent = this.pageDocs$CreateDocsData(
      this.props.data.spyneDocsData.docsContent,
    );
    this.props.data.spyneDocsData.homePageContent =
      this.pageDocs$CreateDocsData(
        this.props.data.spyneDocsData.homePageContent,
      );
    this.props.data.spyneDocsData.toolsPageContent =
      this.pageDocs$CreateDocsData(
        this.props.data.spyneDocsData.toolsPageContent,
      );

    this.props.data.spyneDocsData.investorsPageContent =
        this.pageDocs$CreateDocsData(
            this.props.data.spyneDocsData.investorsPageContent,
        );

    this.props.data.spyneDocsData.comparePageContent =
      this.pageDocs$CreateDocsData(
        this.props.data.spyneDocsData.comparePageContent,
      );
    this.props.data.spyneDocsData.configuratorPageContent =
      this.pageDocs$CreateDocsData(
        this.props.data.spyneDocsData.configuratorPageContent,
      );

    this.props.data.spyneDocsData.capabilitiesPageContent =
        this.pageDocs$CreateDocsData(
            this.props.data.spyneDocsData.capabilitiesPageContent,
        );
    this.props.data.spyneDocsData.referencePageContent =
      this.pageDocs$CreateDocsData(
        this.props.data.spyneDocsData.referencePageContent,
      );

    this.props.data.spyneDocsData.archContent =
        this.pageDocs$CreateDocsData(
            this.props.data.spyneDocsData.archContent,
        );

    this.props.data.spyneDocsData.blogContent =
        this.pageDocs$CreateDocsData(
            this.props.data.spyneDocsData.blogContent,
        );


    this.props.data["codeGenData"] =
      CodeContainerTraits.codeContainer$ConformGenData(safeClone(e[2].payload));

    const action = "CHANNEL_SPYNE_DOCS_DATA_LOADED_EVENT";
    const { data } = this.props;
    this.sendChannelPayload(action, data);

    //console.log("DATA ",this.props.data);

    //console.timeEnd('getData');
  }

  onRegistered() {
    /**
     * TODO: DECOUPLE CODE GEN JSON -- DO NOT NEEED FOR NOW
     * */
    //console.time('getData');
    const appData$ = this.getChannel("CHANNEL_APP_API").pipe(take(1));
    const spyneDocsData$ = this.getChannel("CHANNEL_SPYNE_DOCS_JSON").pipe(
      take(1),
    );
    const codeGenData$ = this.getChannel("CHANNEL_CODE_GEN_JSON").pipe(take(1));
    const data$ = forkJoin([appData$, spyneDocsData$, codeGenData$]);

    //forkJoin(appData$, spyneDocsData$).subscribe(this.onDataReceived.bind(this));
    data$.subscribe(this.onDataReceived.bind(this));

    //console.log('docs data laoded');
  }
  addRegisteredActions() {
    return ["CHANNEL_SPYNE_DOCS_DATA_LOADED_EVENT"];
  }

  onViewStreamInfo(obj) {
    let data = obj.props();
  }
}
